import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Link } from 'gatsby-link';

import './index.scss';

const VimeoBase = (props) => {
    const {
        video,
        videoTitle,
        className,
        containerClassName,
        to,
        controls,
        loop,
        loading,
        title,
    } = props;

    const videoType = /^https?:/i.test(video) ? 'url' : 'id';
    if (videoType === 'url' && !video.includes('vimeo')) {
        return <></>;
    }

    const containerRef = useRef();
    const playerRef = useRef();

    // eslint-disable-next-line react/prop-types
    const WithLink = ({ to, children, className }) =>
        to ? (
            <Link to={to} className={className}>
                {children}
            </Link>
        ) : (
            children
        );

    return (
        <div ref={containerRef} className={clsx('vimeo', containerClassName)}>
            <WithLink className="vimeo__link" to={to}>
                {videoTitle ? (
                    <h2 className="vimeo__heading">{videoTitle}</h2>
                ) : null}
            </WithLink>
            <player-x
                ref={playerRef}
                src={video}
                autoplay=""
                muted=""
                playsinline=""
                loading={loading}
                class={clsx('vimeo__player', className)}
                {...{
                    ...(controls && { controls: '' }),
                    ...(loop && { loop: '' }),
                    ...(title && { title: title }),
                }}
            ></player-x>
        </div>
    );
};

export default VimeoBase;

VimeoBase.propTypes = {
    video: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    videoTitle: PropTypes.string,
    bannerSubHeading: PropTypes.string,
    titleGroupClassNames: PropTypes.string,
    containerClassName: PropTypes.string,
    className: PropTypes.string,
    to: PropTypes.string,
    controls: PropTypes.bool,
    loop: PropTypes.bool,
    loading: PropTypes.string,
    title: PropTypes.string,
};

VimeoBase.defaultProps = {
    videoTitle: '',
    bannerSubHeading: '',
    titleGroupClassNames: '',
    className: '',
    containerClassName: '',
    to: '',
    config: {},
    loading: 'lazy',
    loop: false,
    controls: false,
    title: '',
};
